import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Button, { ButtonIcon, ButtonProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import LazyImage from "@insite/mobius/LazyImage";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useEmblaCarousel from "embla-carousel-react";
import React, { useCallback } from "react";
import { css } from "styled-components";

interface MemberList {
    fields: {
        img: string;
        imgtext: string;
    };
}

interface MyProps {
    carouselData: MemberList[];
    activeCarouselImg: number;
    setActiveCarouselImg: (activeindex: number) => void;
    selectedImgText: string;
    setSelectedImgText: (setSelectedImgText: string) => void;
}

export interface CareerCaraouselStyles {
    blogContainer?: InjectableCss;
    blogCardWithoutCarausal?: InjectableCss;
    prevArrowContainer?: InjectableCss;
    prevArrowButton?: ButtonProps;
    nextArrowContainer?: InjectableCss;
    nextArrowButton?: ButtonProps;
    blogListWrapper?: InjectableCss;
    blogListWrapperContainer?: InjectableCss;
    blogListWrapperWithCarousal?: InjectableCss;
    blogListWrapperWithoutCarousal?: InjectableCss;
    slide?: InjectableCss;
    secondContainer?: InjectableCss;
    secondContainerItems?: InjectableCss;
    img?: InjectableCss;
    activeImgStyle?: InjectableCss;
    notActiveImgStyle?: InjectableCss;
    secondContainerImage?: InjectableCss;
    container?: InjectableCss;
}

export const styles: CareerCaraouselStyles = {
    blogContainer: {
        css: css`
            position: relative;
            width: 100%;
            flex-grow: 1;
        `,
    },

    nextArrowContainer: {
        css: css`
            justify-content: flex-end;
            position: absolute;
            right: 0px;
            top: 0;
            bottom: 0;
            margin-top: auto;
            margin-bottom: auto;
            width: 40px;
            height: 40px;
            overflow: hidden;
            z-index: 2;
        `,
    },
    nextArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
            width: 100%;
            height: 100%;
            background: ${getColor("text.link")};
            border: 1px solid ${getColor("text.link")} !important;
            border-radius: 50%;
            span {
                width: 30px;
                height: 30px;
                padding-left: 3px;
                top: 0 !important;
                > svg {
                    color: #fff;
                    width: 25px;
                    height: 25px;
                }
            }
            &:hover {
                background: #fff;
                svg {
                    color: ${getColor("text.link")};
                }
            }
            &:focus {
                outline: none;
            }
        `,
    },
    prevArrowContainer: {
        css: css`
            justify-content: flex-start;
            position: absolute;
            left: 0px;
            top: 0;
            bottom: 0;
            margin-top: auto;
            margin-bottom: auto;
            width: 40px;
            height: 40px;
            overflow: hidden;
            z-index: 2;
        `,
    },
    prevArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
            width: 100%;
            height: 100%;
            background: ${getColor("text.link")};
            border: 1px solid ${getColor("text.link")} !important;
            border-radius: 50%;
            span {
                width: 30px;
                height: 30px;
                top: 0 !important;
                > svg {
                    color: #fff;
                    width: 25px;
                    height: 25px;
                }
            }
            &:hover {
                background: #fff;
                svg {
                    color: ${getColor("text.link")};
                }
            }
            &:focus {
                outline: none;
            }
        `,
    },
    blogListWrapper: {
        css: css`
            width: 100%;
            position: relative;
            padding: 20px;
            height: 100%;
        `,
    },
    blogListWrapperContainer: {
        css: css`
            overflow: hidden;
            width: 100%;
            height: 100%;
        `,
    },
    blogListWrapperWithCarousal: {
        css: css`
            display: flex;
            height: 100%;
        `,
    },
    slide: {
        css: css`
            display: flex;
            flex: 0 0 100%;
            justify-content: center;
        `,
    },
    blogListWrapperWithoutCarousal: {
        css: css`
            display: flex;
            justify-content: center;
            width: 100%;
        `,
    },

    secondContainer: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: center;
            gap: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },

    secondContainerItems: {
        css: css`
            height: 67px;
        `,
    },
    secondContainerImage: {
        css: css`
            border: 4px solid red;
            border-radius: 6px;
        `,
    },

    img: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 85%;
                        `,
                        null,
                        css`
                            width: auto;
                        `,
                    ],
                    "min",
                )}
            > img {
                max-height: 475px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                @media (orientation: landscape) {
                                    max-height: 100%;
                                    width: auto;
                                    height: 100%;
                                }
                            `,
                            null,
                            null,
                            css`
                                @media (orientation: landscape) {
                                    max-height: 475px;
                                    width: 100%;
                                    height: auto;
                                }
                            `,
                            css`
                                height: 100%;
                            `,
                        ],
                        "min",
                    )}
            }
        `,
    },
    activeImgStyle: {
        css: css`
            > img {
                border: 2px solid ${getColor("text.link")};
                border-radius: 6px;
                height: 100%;
            }
        `,
    },
    notActiveImgStyle: {
        css: css`
            > img {
                height: 100%;
            }
        `,
    },
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            height: 100%;
        `,
    },
};
const CareerCarousel: React.FC<MyProps> = ({
    carouselData,
    setActiveCarouselImg,
    activeCarouselImg,
    selectedImgText,
    setSelectedImgText,
}) => {
    const [emblaRef, embla] = useEmblaCarousel();
    const [, setCanScrollPrev] = React.useState(false);
    const [, setCanScrollNext] = React.useState(false);
    const containerRef = React.createRef<HTMLDivElement>();
    const scrollTo = useCallback((index: number) => embla && embla.scrollTo(index), [embla]);
    const setCanScroll = () => {
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };

    React.useEffect(() => {
        if (!embla) {
            return;
        }

        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);
        embla.reInit({
            slidesToScroll: 1,
            loop: true,
        });
        scrollTo(activeCarouselImg);
    }, [embla]);

    React.useEffect(() => {
        if (!embla) {
            return;
        }
        scrollTo(activeCarouselImg);
    }, [activeCarouselImg]);

    const keyDownHandler = (event: any) => {
        if (event.keyCode === 39) {
            setSelectedImgText(carouselData[activeCarouselImg + 1].fields.imgtext);
            setActiveCarouselImg(activeCarouselImg + 1);
        } else if (event.keyCode === 37) {
            setSelectedImgText(carouselData[activeCarouselImg - 1].fields.imgtext);
            setActiveCarouselImg(activeCarouselImg - 1);
        }
    };

    React.useEffect(() => {
        if (containerRef.current) {
            containerRef.current.focus();
        }
        document.addEventListener("keydown", keyDownHandler, false);
        return () => {
            document.removeEventListener("keydown", keyDownHandler, false);
        };
    }, [activeCarouselImg]);

    return (
        <StyledWrapper ref={containerRef} {...styles.container}>
            <StyledWrapper {...styles.blogContainer}>
                <StyledWrapper {...styles.prevArrowContainer}>
                    <Button
                        {...styles.prevArrowButton}
                        onClick={() => {
                            if (embla) {
                                setSelectedImgText(carouselData[activeCarouselImg - 1].fields.imgtext);
                                setActiveCarouselImg(activeCarouselImg - 1);
                            }
                        }}
                    >
                        <ButtonIcon src={ChevronLeft} />
                    </Button>
                </StyledWrapper>

                <StyledWrapper {...styles.blogListWrapper}>
                    <StyledWrapper {...styles.blogListWrapperContainer} ref={emblaRef}>
                        <StyledWrapper {...styles.blogListWrapperWithCarousal}>
                            {carouselData?.map(division => {
                                return (
                                    <StyledWrapper {...styles.slide} key={division.fields.imgtext}>
                                        <LazyImage {...styles.img} src={division.fields.img}></LazyImage>
                                    </StyledWrapper>
                                );
                            })}
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>

                <StyledWrapper {...styles.nextArrowContainer}>
                    <Button
                        {...styles.nextArrowButton}
                        onClick={() => {
                            if (embla) {
                                setSelectedImgText(carouselData[activeCarouselImg + 1].fields.imgtext);
                                setActiveCarouselImg(activeCarouselImg + 1);
                            }
                        }}
                    >
                        <ButtonIcon src={ChevronRight} />
                    </Button>
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...styles.secondContainer}>
                {carouselData?.map((division, index) => {
                    return (
                        <StyledWrapper {...styles.secondContainerItems} key={index}>
                            <LazyImage
                                {...styles.secondContainerImage}
                                src={division.fields.img}
                                key={index}
                                {...(index === activeCarouselImg
                                    ? { ...styles.activeImgStyle }
                                    : { ...styles.notActiveImgStyle })}
                                onClick={() => {
                                    setActiveCarouselImg(index);
                                    setSelectedImgText(carouselData[index].fields.imgtext);
                                }}
                            ></LazyImage>
                        </StyledWrapper>
                    );
                })}
                <LazyImage></LazyImage>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default CareerCarousel;
